import styled from "styled-components";

export const StyledDatePicker = styled.div`
  .date-picker {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    & > p {
      padding: 6px;
      color: #000;
      font-size: 14px;
      font-weight: 600;
    }
    input {
      outline: none;
      border: 1px solid #d2d2d2;
      padding: 6px 10px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 200;
      width: 130px;
      cursor: pointer;
    }
    .react-datepicker__calendar-icon {
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
    }
    .react-datepicker {
      width: 180px;
      .react-datepicker__current-month {
        font-size: 14px;
        font-weight: 700;
      }
      .react-datepicker__month-container {
        width: 100%;
      }
      .react-datepicker__header {
        margin-bottom: 4px;
        padding-bottom: 0;
      }
      .react-datepicker__day-names {
        display: flex;
        justify-content: center;
        gap: 2px;
        padding: 4px 0;
        .react-datepicker__day-name {
          padding: 2px;
          font-size: 10px;
          width: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:first-child {
            color: #f06548;
          }
          &:last-child {
            color: #4679cc;
          }
        }
      }
      .react-datepicker__week {
        display: flex;
        justify-content: center;
        padding-bottom: 4px;
        gap: 2px;
        .react-datepicker__day {
          background-color: transparent;
          padding: 2px;
          font-size: 10px;
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .react-datepicker__day--in-selecting-range {
          background-color: #4679cc;
          color: #fff;
        }
        .react-datepicker__day--outside-month {
          color: #d2d2d2;
          &.react-datepicker__day--in-selecting-range {
            opacity: 0.4;
          }
        }
      }
    }
  }
`;
